import React from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import { Icon } from '../../components';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

const TileHeaderComponent = ({ children, containerStyle, canNavigate = true }) => {
    return <View style={[styles.headingContainer, containerStyle]}>
        <Text style={styles.title}>{children}</Text>
        {canNavigate &&
            <View style={styles.arrowContainer}>
                <Icon
                    size={defaultScale(18)}
                    color={Theme.GREY_DARK_MEDIUM}
                    name='ios-arrow-forward'
                />
            </View>
        }
    </View>;
};

const styles = StyleSheet.create({
    headingContainer: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    title: {
        ...Theme.textStyle.heading,
        color: Theme.BLACK,
    },
    arrowContainer: {
        alignSelf: 'center',
        paddingRight: defaultScale(5),
    },
});

export const TileHeader = translate(['bodyscan'])(TileHeaderComponent);
